import { Box, Tooltip } from "@mui/material"



export const CowcategoryListBadge = ({ cow_list, old_cow_cat }) => {
    const occ = old_cow_cat || 7
    console.log(old_cow_cat, occ)
    if (cow_list && cow_list.length > 0) {
        const young = cow_list.filter(c => c.category?.category_number<occ)
        const old = cow_list.filter(c => c.category?.category_number>=occ)
        const extra = cow_list.filter(c => !c.category || !c.category.id)
        let title = ''
        if (young.length > 0) {
            title = 'Manze/Giovenche: ' + young.length
        }
        if (old.length > 0) {
            title = title += ' Vacche: ' + old.length
        }
        if (extra.length > 0) {
            title = title += ' N.C.: ' + extra.length
        }
        return (
            <Tooltip title={title}>
                <Box sx={{ borderRadius: 2, display: 'inline-flex', flexDirection: "row", fontSize: '0.8em', overflow: 'auto' }}>
                    {young.length > 0 && <Box sx={{ minWidth: '30px', backgroundColor: 'blue', color: 'white', textAlign:'center', paddingLeft:1, paddingRight:0.5 }}>{young.length} giovenche</Box>}
                    {old.length > 0 && <Box sx={{ minWidth: '30px', backgroundColor: 'brown', color: 'white', textAlign:'center', paddingRight:1, paddingLeft:0.5 }}>{old.length} vacche</Box>}
                </Box>
            </Tooltip>
        )
    } else {
        return <></>
    }
}

